import React from "react";
import { ReactComponent as UpArrow } from "../../assets/icons/up-arrow.svg";
import { ReactComponent as Flag } from "../../assets/icons/custom-flag.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/UserOutline.svg";
import { ReactComponent as RefreshIcon } from "../../assets/icons/RefreshIcon.svg";
export const riskLookup = {
  urgent: {
    text: "URGENT",
    icon: UpArrow,
    color: "#F04438",
    bgcolor: "#ffeceb",
  },
  high: {
    text: "RED FLAG",
    icon: UpArrow,
    color: "#F04438",
    bgcolor: "#ffeceb",
  },
  RED: {
    text: "RED FLAG",
    icon: UpArrow,
    color: "#F04438",
    bgcolor: "#ffeceb",
  },
  red: {
    text: "RED FLAG",
    icon: UpArrow,
    color: "#F04438",
    bgcolor: "#ffeceb",
  },
  medium: {
    text: "YELLOW FLAG",
    icon: UpArrow,
    color: "#F4D03F",
    bgcolor: "#fff4e6",
  },
  triage: {
    text: "YELLOW FLAG",
    icon: UpArrow,
    color: "#F4D03F",
    bgcolor: "#fff4e6",
  },
  YELLOW: {
    text: "YELLOW FLAG",
    icon: UpArrow,
    color: "#F4D03F",
    bgcolor: "#fff4e6",
  },
  yellow: {
    text: "YELLOW FLAG",
    icon: UpArrow,
    color: "#F4D03F",
    bgcolor: "#fff4e6",
  },
  low: {
    text: "GREEN FLAG",
    icon: UpArrow,
    color: "#12B76A",
    bgcolor: "#eafff5",
  },
  GREEN: {
    text: "GREEN FLAG",
    icon: UpArrow,
    color: "#12B76A",
    bgcolor: "#eafff5",
  },

  ready: {
    text: "Ready",
    icon: UpArrow,
    color: "#12B76A",
    bgcolor: "#eafff5",
  },
  green: {
    text: "GREEN FLAG",
    icon: UpArrow,
    color: "#12B76A",
    bgcolor: "#eafff5",
  },
  eligible: {
    text: "Eligible",
    icon: UpArrow,
    color: "#DD8903",
    bgcolor: "#FFF4E2",
  },
  enrolled: {
    text: "Enrolled",
    icon: UpArrow,
    color: "#2383B9",
    bgcolor: "#D6F0F9",
  },
  "not eligible": {
    text: "Not Eligible",
    icon: UpArrow,
    color: "#395e9d",
    bgcolor: "#f1f1f5",
  },
  "not ready": {
    text: "Not Ready",
    icon: UpArrow,
    color: "#395e9d",
    bgcolor: "#f1f1f5",
  },
  provider: {
    text: "Provider",
    icon: UserIcon,
    color: "#044CB9",
    bgcolor: "#f1f1f5",
  },
  other: {
    text: "Other",
    icon: UserIcon,
    color: "#d97706",
    bgcolor: "#fff4e6",
  },
  "not specified": {
    text: "Not Specified",
    icon: UserIcon,
    color: "gray",
    bgcolor: "#f5f2f2",
  },
  "accountable_care_organization_(aco)": {
    text: "ACO",
    icon: UserIcon,
    color: "#12B76A",
    bgcolor: "#eafff5",
  },
  default: {
    text: "Not on File",
    icon: UpArrow,
    // color: "#395e9d",
    // bgcolor: "#f1f1f5",
    color: "#12B76A",
    bgcolor: "#eafff5",
  },
};

export const SplitRiskPill = ({
  type,
  icon_type = "arrow",
  icon_height = "10px",
  icon_width = "10px",
  icon_styles = {},
  styles = {},
  classnames = "",
  custom_text = null,
  show_icon = true,
  onClick = null,
}) => {
  const risk = riskLookup[type] || riskLookup["default"];
  return (
    <div
      className={`risk-pill ${classnames}`}
      style={{
        backgroundColor: `${risk["bgcolor"]}`,
        color: `${risk["color"]}`,
        ...styles,
      }}
    >
      {show_icon && icon_type === "arrow" && (
        <UpArrow
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
        />
      )}
      {show_icon && icon_type === "flag" && (
        <Flag
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
          fill={risk["color"]}
        />
      )}
      {show_icon && icon_type === "user" && (
        <UserIcon
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
          fill={risk["color"]}
        />
      )}{" "}
      <label
        style={{
          color: `${risk["color"]}`,
          fontSize: "0.6vw",
          userSelect: "none",
          textTransform: "capitalize",
        }}
      >
        {custom_text ? custom_text : risk["text"]}
      </label>{" "}
      |{" "}
      <label
        style={{ color: risk["color"], cursor: "pointer" }}
        onClick={() => {
          onClick();
        }}
      >
        <small>Reset</small>
      </label>
      {/* <RefreshIcon
        style={icon_styles}
        height={icon_height}
        width={icon_width}
        stroke={risk["color"]}
        fill={risk["color"]}
        onClick={() => {
          onClick();
        }}
      /> */}
    </div>
  );
};

const RiskPill = ({
  type,
  icon_type = "arrow",
  icon_height = "12px",
  icon_width = "12px",
  icon_styles = {},
  styles = {},
  classnames = "",
  custom_text = null,
  show_icon = true,
  show_text = true,
}) => {
  const risk = riskLookup[type] || riskLookup["default"];
  return (
    <div
      className={`risk-pill ${classnames}`}
      style={{
        backgroundColor: `${risk["bgcolor"]}`,
        color: `${risk["color"]}`,
        ...styles,
      }}
    >
      {show_icon && icon_type === "arrow" && (
        <UpArrow
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
        />
      )}
      {show_icon && icon_type === "flag" && (
        <Flag
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
          fill={risk["color"]}
        />
      )}
      {show_icon && icon_type === "user" && (
        <UserIcon
          style={icon_styles}
          height={icon_height}
          width={icon_width}
          stroke={risk["color"]}
          fill={risk["color"]}
        />
      )}{" "}
      {show_text && (
        <label
          style={{
            color: `${risk["color"]}`,
            userSelect: "none",
            textTransform: "capitalize",
          }}
        >
          {custom_text ? custom_text : risk["text"]}
        </label>
      )}
    </div>
  );
};

export default RiskPill;
